import {
  IEventIndividualActionTypes,
  IEventIndividualType,
  IEventActionCreator,
} from "models/IEventState";

const initialState: IEventIndividualType = {};

const reducer = (state = initialState, { type, payload }: IEventActionCreator) => {
  switch (type) {
    case IEventIndividualActionTypes.FETCH_EVENT_INDIVIDUAL_REQUEST:
      return {
        ...state,
        data: {},
      };
    case IEventIndividualActionTypes.FETCH_EVENT_INDIVIDUAL_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
